import React from 'react'
import Slider from "react-slick";

function Clients() {
    const settings = {
        dots: false,
        infinite: true,
        slidesToShow: 6,
        slidesToScroll: 1,
        autoplay: true,
        speed: 4000,
        autoplaySpeed:1000,
        cssEase: "linear",
        arrows: false,
        responsive: [
            {
              breakpoint: 1024,
              settings: {
                slidesToShow: 4,
                slidesToScroll: 1,
              }
            },
            {
              breakpoint: 600,
              settings: {
                slidesToShow: 2,
                slidesToScroll: 2,
              }
            },
            {
              breakpoint: 480,
              settings: {
                slidesToShow: 2,
                slidesToScroll: 1
              }
            }
          ]
      };
    const imgData = [
        {
            id:1,
            url:'./images/clients/assra-creations.webp'
        },
        {
            id:2,
            url:'./images/clients/atlas-logo.webp'
        },
        {
            id:3,
            url:'./images/clients/Banaras_center.webp'
        },
        {
            id:4,
            url:'./images/clients/big-chill.webp'
        },
        {
            id:5,
            url:'./images/clients/gift4all-logo.webp'
        },
        {
            id:6,
            url:'./images/clients/sampark.webp'
        },
        {
            id:7,
            url:'./images/clients/uncle-docs.webp'
        },
        {
            id:8,
            url:'./images/clients/grassroot-tea.webp'
        },
        {
            id:9,
            url:'./images/clients/freezerbaazar.webp'
        },
        {
            id:10,
            url:'./images/clients/nihao.webp'
        },
        {
            id:11,
            url:'./images/clients/shipzoi.webp'
        }
    ]
  return (
    <>
        <section>
            <div className="our-clients">
                <div className="container-fluid">
                  <div className="card p-0 border-0 bg-transparent">
                      <Slider {...settings}>
                          {imgData.map((cur_elm)=>
                              <div key={cur_elm.id}>
                                  <div className="card ms-3 border-0 d-flex justify-content-center align-items-center bg-transparent">
                                      <img src={cur_elm.url} alt="Client logo" />
                                  </div>
                              </div>
                          )}
                      </Slider>
                  </div>
                </div>
            </div>
        </section>
    </>
  )
}

export default Clients